import { EvidenceSubmission, SubmitterOutcome } from "@/backend/models/evidenceSubmission";
import { I18n } from "@/i18n/I18n";

const SUBMITTER_OUTCOME_BADGES = {
  [SubmitterOutcome.PASSED]: { color: 'success', label: I18n.get('submittedAsPassing') },
  [SubmitterOutcome.FAILED]: { color: 'danger', label: I18n.get('submittedAsFailing') },  
  [SubmitterOutcome.PENDING]: { color: 'secondary', label: I18n.get('pending') },
  [SubmitterOutcome.DEVIATED]: { color: 'warning', label: I18n.get('submittedAsDeviated') },
};

export function SubmissionInformation({ submission }: { submission: EvidenceSubmission }) {
  return (
    <>
      <div className={`fusa-badge bg-${SUBMITTER_OUTCOME_BADGES[submission.submitterOutcome].color}`}>
        {SUBMITTER_OUTCOME_BADGES[submission.submitterOutcome].label}
      </div>
      <p className="list-card-meta">{submission.submittedBy}</p>
      <p className="list-card-meta">{new Date(submission.submittedAt).toLocaleString(undefined, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</p>
    </>  
  );
}
